// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

const language = window.location.pathname === "/en/" || window.location.pathname.startsWith("/en/") ? "en" : "es";
const languageKey = language === "en" ? "En" : "Es";
document.documentElement.lang = language === "en" ? "en" : "es-MX";

document.querySelectorAll(`[data-i18n-${language}]`).forEach((element) => {
    element.textContent = element.dataset[`i18n${languageKey}`];
});

document.querySelectorAll(`[data-i18n-aria-${language}]`).forEach((element) => {
    element.setAttribute("aria-label", element.dataset[`i18nAria${languageKey}`]);
});

document.querySelectorAll("[data-language-link]").forEach((link) => {
    const translations = {
        "/las-condolencias/": "/en/expressing-condolences/",
        "/las-flores-y-su-lenguaje-propio/": "/en/flowers-and-their-language/",
        "/que-es-tanatologia/": "/en/what-is-thanatology/",
        "/como-sobrellevar-el-duelo-en-una-fecha-especial/": "/en/coping-with-grief-on-a-special-date/",
        "/mis-redes-sociales/": "/en/my-social-media-accounts/"
    };
    const reverseTranslations = Object.fromEntries(Object.entries(translations).map(([spanish, english]) => [english, spanish]));

    if (link.dataset.languageLink === "en" && translations[window.location.pathname]) {
        link.href = translations[window.location.pathname];
    }

    if (link.dataset.languageLink === "es" && reverseTranslations[window.location.pathname]) {
        link.href = reverseTranslations[window.location.pathname];
    }

    if (link.dataset.languageLink === language) {
        link.setAttribute("aria-current", "page");
    }
});
